import React, { useMemo } from 'react';
import { ETabKeys, NSConsignment } from '../../Consignment.d';
import { TabActive, TabHistory, TabInProgress, TabPending } from './Components';
import Style from './Tab.module.scss';
import classNames from 'classnames';

interface ITabProps {
  activeKey: NSConsignment.TTabKeys;
  onChangeTab: (param: NSConsignment.TTabKeys) => void;
}

const TABS = [
  'Pending',
  'Active',
  'In Progress',
  'History',
] as NSConsignment.TTabKeys[];

const Tab: React.FC<ITabProps> = (props) => {
  const { activeKey, onChangeTab } = props;

  const TabContent = useMemo(() => {
    if (activeKey === ETabKeys.Pending) {
      return <TabPending onChangeTab={onChangeTab}/>;
    }

    if (activeKey === ETabKeys.InProgress) {
      return <TabInProgress />;
    }

    if (activeKey === ETabKeys.Active) {
      return <TabActive />;
    }

    if (activeKey === ETabKeys.History) {
      return <TabHistory />;
    }
  }, [activeKey]);

  return (
    <div>
      <div className={classNames('tab-container', Style['tab'])}>
        {TABS.map((key) => {
          let classDiv = 'tabs';
          if (activeKey === key) {
            classDiv += ' active';
          }

          return (
            <div key={key} className={classDiv} onClick={() => onChangeTab(key)}>
              <p>{key}</p>
              {activeKey === key && <div className={'is-active-tabs'} />}
            </div>
          );
        })}
      </div>
      <div className={'tab-content'}>{TabContent}</div>
    </div>
  );
};

export default Tab;
